<template>
	<div class="stat-box">
		<div class="stat-box-header">
			<div class="flex align-items-center surface-card">
				<div style="width:48px;height:48px;border-radius:10px" class="bg-purple-100 inline-flex align-items-center justify-content-center mr-3">
					<i class="pi pi-chart-line text-purple-500 text-3xl"></i>
				</div>
				<div>
					<span class="text-900 text-xl font-medium mb-2">{{ $t('historique') }}</span>
					<p class="mt-1 mb-0 text-600 font-medium text-sm">{{ $t('des_volumes') }}
						<tool-source url='' :txt="'Adequation'"/>
					</p>
				</div>
				<div class="ml-auto">
					<div class="speeddial-tooltip-demo">
						<SpeedDial className="speeddial-left" :model="items" direction="down" showIcon="pi pi-bars" hideIcon="pi pi-times" buttonClassName="p-button-outlined"/>
					</div>
				</div>
			</div>
			<TabPeriode/>
		</div>
		<div class="stat-box-content">
			<div class="data-container">
				<div class="table-container">

					<table id='historique_volume' class="data-table">
						<thead>
							<tr class="period-header">
								<th id="volume_11">Historique sur {{ getNbPeriode }} {{ getLibellePeriode }}</th>
								<th v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_titre_' + i"  class="period-date">
									{{ TraitementTitre(stat[getIndexPeriode]) }}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="section-header" colspan="9" id="volume_21"><span class="material-icons section-icon">business</span>PROGRAMMES</td>
							</tr>
							<tr>
								<td>
									<div class="metric-label">
										Programmes actifs
									</div>
								</td>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_nbp_' + i" class="metric-value highlight">
									{{ stat['volume']['programmes_actifs'] }}
								</td>
							</tr>
							<tr class="subsection-row">
								<td id="volume_21">
									<div class="metric-label">
										→ Nouveaux programmes
									</div>
								</td>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_nbnp_' + i" class="metric-value">
									{{ stat['volume']['programmes_nouveaux'] }}
								</td>
							</tr>
							<tr>
								<td class="section-header" colspan="9">
									<span class="material-icons section-icon">inventory</span>
									LOTS
								</td>
							</tr>
							<tr>
								<td>
									<div class="metric-label">
										Ventes brutes
									</div>
								</td>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_vtb_' + i" class="metric-value highlight">
									{{ stat['volume']['ventes_brutes'] }}
								</td>
							</tr>
							<tr class="subsection-row">
								<td>
									<div class="metric-label">
										→ Désistements
									</div>
								</td>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_des_' + i" class="metric-value">
									{{ stat['volume']['ventes_brutes'] - stat['volume']['ventes_nettes'] }}
								</td>
							</tr>
							<tr class="bord_vert">
								<td>
									<div class="metric-label">
										<strong>Ventes nettes</strong>
									</div>
								</td>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_vtn_' + i" class="metric-value highlight">
									<div class="fe">
										<div class="">{{ stat['volume']['ventes_nettes'] }}</div>
									</div>
								</td>
							</tr>
							<tr class="subsection-row bord_bleu">
								<td>
									<div class="metric-label">
										→ Mises en vente
									</div>
								</td>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_mev_' + i" class="metric-value highlight">
									<div class="fe">
										<div class="">{{ stat['volume']['mises_en_vente'] }}</div>
									</div>
								</td>
							</tr>
							<tr class="subsection-row">
								<td>
									<div class="metric-label">
										→ Retraits de commercialisation
									</div>
								</td>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_ret_' + i" class="metric-value">
									{{ stat['volume']['retrait_de_commercialisation'] }}
								</td>
							</tr>
							<tr class="bord_rouge">
								<td>
									<div class="metric-label">
										<strong>Offre disponible</strong>
									</div>
								</td>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_ofr_' + i" class="metric-value highlight">
									<div class="fe">
										<div class="">{{ stat['volume']['offre'] }}</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>




					<!--
					<table id='historique_volume'>
						<tbody>
							<tr>
								<th id="volume_11">Historique sur {{ getNbPeriode }} {{ getLibellePeriode }}</th>
								<th v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_titre_' + i" class="titre_periode">
									{{ TraitementTitre(stat[getIndexPeriode]) }}
								</th>
							</tr>
							<tr>
								<th id="volume_21">Nombre de programmes actifs</th>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_nbp_' + i">
									{{ stat['volume']['programmes_actifs'] }}
								</td>
							</tr>
							<tr>
								<th id="volume_21">Nombre de tranches actives</th>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_nbt_' + i">
									{{ stat['volume']['tranches_actives'] }}
								</td>
							</tr>
							<tr>
								<th id="volume_21">Nombre de nouveaux programmes</th>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_nbnp_' + i">
									{{ stat['volume']['programmes_nouveaux'] }}
								</td>
							</tr>
							<tr>
								<th id="volume_21">Nombre de nouvelles tranches</th>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_nbnt_' + i">
									{{ stat['volume']['tranches_nouvelles'] }}
								</td>
							</tr>
							<tr>
								<th id="volume_31">Mises en vente</th>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_mev_' + i" class="highlight">
									{{ stat['volume']['mises_en_vente'] }}
								</td>
							</tr>
							<tr>
								<th id="volume_41">Ventes brutes</th>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_vtb_' + i">
									{{ stat['volume']['ventes_brutes'] }}
								</td>
							</tr>
							<tr>
								<th id="volume_41">Désistements</th>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_des_' + i">
									{{ stat['volume']['ventes_brutes'] - stat['volume']['ventes_nettes'] }}
								</td>
							</tr>
							<tr>
								<th id="volume_41">Ventes nettes</th>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_vtn_' + i" class="highlight">
									{{ stat['volume']['ventes_nettes'] }}
								</td>
							</tr>
							<tr>
								<th id="volume_41">Retraits de commercialisation</th>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_ret_' + i" class="highlight">
									{{ stat['volume']['retrait_de_commercialisation'] + stat['volume']['retrait_suite_veb'] }}
								</td>
							</tr>
							<tr>
								<th id="volume_51">Offre</th>
								<td v-for="(stat, i) in getStat.slice().reverse()" :key="'stat_volume_ofr_' + i" class="highlight">
									{{ stat['volume']['offre'] }}
								</td>
							</tr>
						</tbody>
					</table>
					-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import SpeedDial from 'primevue/speeddial';
import TabPeriode from '../TabPeriode.vue';
import ToolSource from '../../../../global/ToolSource';

export default {
	name: 'ArrayHistoriqueVm',
	props: {
		periode_forme: { default: 'statistique_secteurs_trimestre' },
		nbperiode: { default: 8 },
		cle: { default: 'trimestre' },
		libperiode: { default: 'trimestres' },
	},
	
	data: function() {
		return {
			tab: 'mois',
			items: [
				{label: 'Data', icon: 'pi pi-fw pi-download', command:() => {this.$store.dispatch('ExportToXls',{id: 'historique_volume', name: 'Historique des volumes'});} },
				{label: 'Image', icon: 'pi pi-fw pi-image', command:() => {this.$store.dispatch('ExportToPng',{id: 'historique_volume'});} },
			]
		}
	},

	methods: {
		ChangeTab: function(periodicite) {
			this.$store.dispatch('change_periodicite', { periodicite: periodicite })
		},

		toggle(event) {
			this.$refs.menu.toggle(event);
		},

		TraitementTitre: function(t) {
			if (this.app.tab == 'trimestres') {
				return t.slice(-4);
			} else return t;
		},

	},

	computed: Object.assign(mapGetters([ 'app' ]), {
		getStat: function() {
			return this.app.livedata[this.periode_forme];
		},

		getIndexPeriode: function() {
			return this.cle;
		},

		getLibellePeriode: function() {
			return this.libperiode;

		},

		getNbPeriode: function() {
			return this.nbperiode;

		},
	}),

	components: { ToolSource, SpeedDial, TabPeriode }
}
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'

table
	background-color white

td
	text-align right !important
	border-right 1px solid #dcdcdc

.titre_periode
	text-align center

.highlight
	font-weight 500

.p-menuitem-link
	padding 0.75rem 1.25rem !important
	color #495057
	border-radius 0
	transition box-shadow 0.2s
	user-select none

:deep(.speeddial-tooltip-demo) {
	.p-speeddial-direction-up {
		&.speeddial-left {
			left: 0;
			bottom: 0;
		}
		&.speeddial-right {
			right: 0;
			bottom: 0;
		}
	}
	.p-speeddial-button.p-button.p-button-icon-only {
		width: 3rem !important;
		height: 3rem !important;
	}

}	





















        .data-container {
            background: #ffffff;
            //border-radius: 12px;
            //box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
            overflow: hidden;
        }
        
        .table-container {
            overflow-x: auto;
        }
        
        .data-table {
            width: 100%;
            border-collapse: collapse;
			z-index: 0;
        }
        
        .data-table th {
            background: #f8f9fa;
            padding: 16px 20px;
            text-align: left;
            font-size: 12px;
            font-weight: 600;
            color: #6c757d;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            border-bottom: 1px solid #e9ecef;
            position: sticky;
            top: 0;
            z-index: 10;
        }
        
        .data-table th:first-child {
            min-width: 250px;
            max-width: 250px;
        }
        
        .period-header {
            text-align: center;
            min-width: 100px;
            position: relative;
        }
        
        .period-label {
            font-size: 11px;
            color: #adb5bd;
            display: block;
            margin-bottom: 2px;
        }
        
        .period-date {
            font-size: 13px;
            font-weight: 600;
            color: #343a40;
			text-align: center !important;
        }
        
        .data-table td {
            padding: 12px 20px;
            border-bottom: 1px solid #f8f9fa;
            font-size: 14px;
            color: #343a40;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .data-table tr:hover td:not(.section-header) {
            background: rgba(108, 92, 231, 0.03);
        }
        
        .metric-label {
            font-weight: 500;
            color: #343a40;
            display: flex;
            align-items: center;
            gap: 10px;
            justify-content: flex-start;
        }
        
        .metric-icon {
            width: 28px;
            height: 28px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            flex-shrink: 0;
        }
        
        .metric-icon.programs {
            background: rgba(108, 92, 231, 0.1);
            color: #6c5ce7;
        }
        
        .metric-icon.sales {
            background: rgba(39, 174, 96, 0.1);
            color: #27ae60;
        }
        
        .metric-icon.stock {
            background: rgba(243, 156, 18, 0.1);
            color: #f39c12;
        }
        
        .metric-icon.movements {
            background: rgba(231, 76, 60, 0.1);
            color: #e74c3c;
        }
        
        .metric-value {
            text-align: center;
            font-weight: 400;
            position: relative;
        }
        
        .metric-value.highlight {
            //color: #6c5ce7;
            //background: rgba(108, 92, 231, 0.05);
            border-radius: 4px;
			font-weight: 500;
        }
        
        .metric-value.positive {
            color: #27ae60;
        }
        
        .metric-value        .negative {
            color: #e74c3c;
        }
        
        .calculation-row {
            background: rgba(108, 92, 231, 0.03) !important;
            border-left: 3px solid #6c5ce7 !important;
        }
        
        .calculation-row .metric-label {
            font-weight: 600;
        }
        
        .section-header {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
            color: #343a40 !important;
            font-size: 13px !important;
            font-weight: 700 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.8px !important;
            padding: 16px 20px !important;
            border-top: 2px solid #6c5ce7 !important;
            border-bottom: 1px solid #e9ecef !important;
			text-align: left !important;
        }
        
        .section-header .section-icon {
            margin-right: 8px;
            font-size: 16px;
            color: #6c5ce7;
        }
        
        .subsection-row {
            background: rgba(248, 249, 250, 0.5) !important;
        }
        
        .subsection-row .metric-label {
            font-size: 13px;
            color: #6c757d;
            justify-content: flex-start;
        }
        
        .subsection-row .metric-icon {
            width: 24px;
            height: 24px;
            font-size: 12px;
        }
        
        .empty-state {
            color: #adb5bd;
            font-style: italic;
            text-align: center;
        }
        
        .tooltip {
            position: relative;
            cursor: help;
        }
        
        .tooltip .material-icons {
            font-size: 16px;
            color: #adb5bd;
        }
        
        .tooltip:hover::after {
            content: attr(data-tooltip);
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            background: #343a40;
            color: white;
            padding: 6px 10px;
            border-radius: 4px;
            font-size: 11px;
            white-space: nowrap;
            z-index: 1000;
            margin-bottom: 4px;
        }
        

        .trend-indicator {
            position: absolute;
            top: -2px;
            right: -2px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #27ae60;
        }
        
        .trend-indicator.down {
            background: #e74c3c;
        }
        
        /* SECTION ANALYSE */
        .analysis-container {
            background: #ffffff;
            border-radius: 12px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
            margin-top: 20px;
            overflow: hidden;
        }
        
        .analysis-header {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            padding: 20px 24px;
            border-bottom: 1px solid #e9ecef;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
		.highlight-red {
            background-color: #fca5a5;
            color: #7f1d1d;
            padding: 4px 8px;
            border-radius: 4px;
            font-weight: 600;
            min-width: 15px;
			width: fit-content;
        }
        
        .highlight-green {
            background-color: #86efac;
            color: #14532d;
            padding: 4px 8px;
            border-radius: 4px;
            font-weight: 600;
            min-width: 15px;
			width: fit-content;
        }
        
        .highlight-blue {
            background-color: #93c5fd;
            color: #1e3a8a;
            padding: 4px 8px;
            border-radius: 4px;
            font-weight: 600;
            min-width: 15px;
			width: fit-content;
        }

		.fe {
			display: flex;
			justify-content: flex-end;
		}

		.bord_vert {
			border-left: 3px solid #8dc259 !important;
		}

		.bord_bleu {
			border-left: 3px solid #2b95ed !important;
		}

		.bord_rouge {
			border-left: 3px solid #f1493d !important;
		}
</style>
